/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:26:53
 * @Explain: 邮件配置
 */

export default {
  // 设置管理
  'SETTING.MANAGE.SENDER.INFO': 'Sender Information',
  'SETTING.MANAGE.SENDING.STRATEGY': 'Delivery strategy',
  'SETTING.MANAGE.DATA.SYNCHRONIZATION':
    'Data synchronization (for developers)',
  'SETTING.MANAGE.FOR.DEVELOPERS': 'For developers',
  'SETTING.MANAGE.TEST.LISTS': 'Testers list',

  // 用户管理
  'USERS.MANAGE.LIST.USER.ROLE': 'Project users',
  'USERS.MANAGE.LIST.USER.TITLE': 'User management',
  'USERS.MANAGE.LIST.USERNAME': 'Username',
  'USERS.MANAGE.LIST.ROLE': 'Role',
  'USERS.MANAGE.LIST.EMAIL.ADDRESS': 'Email address',
  'USERS.MANAGE.LIST.JOINING.TIME': 'Registration date',
  'USERS.MANAGE.LIST.2AF.STATUS': '2FA status',
  'USERS.MANAGE.LIST.BEING.INVITED': 'Invitation pending',
  'USERS.MANAGE.LIST.INVITER': 'Inviter',
  'USERS.MANAGE.LIST.INVITE.USER': 'Invite new user',
  'USERS.MANAGE.LIST.EDIT.USER': 'Edit user',
  'USERS.MANAGE.LIST.DEL.USER': 'Delete user',
  'USERS.MANAGE.LIST.DEL.USER.TIPS':
    'You are about to remove this user from this project. All access for this user will be revoked.',
  'USERS.MANAGE.LIST.REINVITE': 'Resend invitation email',
  'USERS.MANAGE.LIST.REINVITE.SUCCESS': 'Invitation has been resent',

  'USERS.MANAGE.ADD.EDIT.INVITE.TITLE': 'Invitation information',
  'USERS.MANAGE.ADD.EDIT.INVITE': 'Invite',
  'USERS.MANAGE.ADD.EDIT.EMAIL': "Enter the user's email address",
  'USERS.MANAGE.ADD.EDIT.ENTER.EMAIL': 'Enter email address',
  'USERS.MANAGE.ADD.EDIT.EMAIL.EXIST':
    'This user has already joined the project, their role can be edited directly',
  'USERS.MANAGE.ADD.EDIT.CHOOSE.ROLE': 'Choose a role for this user',
  'USERS.MANAGE.ADD.SUBMIT.SUCCESS':
    "You have invited {email} as '({role})' to join your project",

  'USERS.MANAGE.MY.PROFILES.BASIC': 'Account information',
  'USERS.MANAGE.MY.PROFILES.USERNAME': 'Username',
  'USERS.MANAGE.MY.PROFILES.EMAIL.ADDRESS': 'Email address',
  'USERS.MANAGE.MY.PROFILES.ACCOUNT.SECURITY': 'Account security',
  'USERS.MANAGE.MY.PROFILES.2FA.TITLE': 'Two - factor authentication(2FA)',
  'USERS.MANAGE.MY.PROFILES.AUTHENTICATOR.APP': 'Authenticator app',
  'USERS.MANAGE.MY.PROFILES.AUTHENTICATOR.APP.DESC':
    'Use an authenticator app or browser extension to receive 2FA authentication codes.',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE': 'Scan the QR code',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE.DESC':
    'Use an authenticator app like Google Authenticator, Microsoft Authenticator, Auth to scan the QR code.',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE.TIPS1':
    'Unable to scan the QR code? You can use the ',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE.TIPS2': 'setup key',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE.TIPS3':
    ' to manually set up your authenticator app.',
  'USERS.MANAGE.MY.PROFILES.ENTER.SIX.DIGIT.CODE':
    'Enter the 6-digit code generated by the authenticator app',
  'USERS.MANAGE.MY.PROFILES.BACKUP.VERIFY.CODES': 'Backup codes',
  'USERS.MANAGE.MY.PROFILES.BACKUP.VERIFY.CODES.DESC':
    'If 2FA is enabled on your account and you lose access to your device, you can use any of these backup codes to regain access your SmartLink account.',
  'USERS.MANAGE.MY.PROFILES.COPY.CODE': 'Copy codes',
  'USERS.MANAGE.MY.PROFILES.COPY.CODE.FIRST':
    'Make sure you have copied these codes',
  'USERS.MANAGE.MY.PROFILES.ENABLE.2FA': 'Enable 2FA',
  'USERS.MANAGE.MY.PROFILES.YOU.2FA.KEY': 'Your 2FA secret key',
  'USERS.MANAGE.MY.PROFILES.DISABLED.2FA': 'Disable 2FA',
  'USERS.MANAGE.MY.PROFILES.DISABLED.2FA.DESC':
    'After disabling 2FA, only username and password are required to log in',
  'USERS.MANAGE.MY.PROFILES.DISABLED.SUCCESS': '2FA disabled successfully',
  'USERS.MANAGE.MY.PROFILES.ENABLE.SUCCESS': '2FA enabled successfully',
  'USERS.MANAGE.MY.PROFILES.TIME.SETTING': 'Time setting',
  'USERS.MANAGE.MY.PROFILES.TIMEZONE': 'Time zone',
  'USERS.MANAGE.MY.PROFILES.TIME.FORMAT': 'Time/data format',

  // 域名配置 - 发送域名设置
  'DOMAIN.NAME.CONFIG.TITLE': 'Domain name configuration',
  'DOMAIN.NAME.CONFIG.DESC':
    'Configure your domain before adding your sender address(es)',
  'DOMAIN.NAME.CONFIG.ADD': 'Add domain',
  'DOMAIN.NAME.CONFIG.SEND.OTHER':
    '{platform} (supports adding verified sender domains from the following partners)',
  'DOMAIN.NAME.CONFIG.SEND.PLACEHOLDER.TENCENT':
    'Enter your domain name. Provide domain name DSN configuration access to facilitate domain name verification later.',
  'DOMAIN.NAME.CONFIG.SEND.PLACEHOLDER.OTHER':
    'Enter a verified domain, otherwise emails may fail to be sent out.',
  'DOMAIN.NAME.CONFIG.SEND.MSG':
    'The character limit is 100 characters. You can use numbers, letters and "-". But "-" cannot be used consecutively and cannot be used at the start or at the end.',
  'DOMAIN.NAME.CONFIG.SEND': 'Sender domain name',
  'DOMAIN.NAME.CONFIG.STATE': 'Status',
  'DOMAIN.NAME.CONFIG.TO.BE.VERIFIED': 'Pending verification',
  'DOMAIN.NAME.CONFIG.VERIFICATION.PASSED': 'Verified',
  'DOMAIN.NAME.CONFIG.VERIFICATION.FAILED': 'Verification failed',
  'DOMAIN.NAME.CONFIG.VERIFYING': 'Verification in progress',
  'DOMAIN.NAME.CONFIG.NO.VERIFICATION.REQUIRED': 'No verification required',
  'DOMAIN.NAME.CONFIG.NO.VERIFY.SUBMITTED': 'Request submitted',
  'DOMAIN.NAME.CONFIG.NO.VERIFY.SUBMITTED.DESC':
    'The verification application for sender domain <b>{address}</b> has been submitted',
  'DOMAIN.NAME.CONFIG.DEL.TITLE':
    "Are you sure you want to delete domain '{address}'?",
  'DOMAIN.NAME.CONFIG.DEL.DESC':
    'Once the domain has been deleted, it cannot be used to send emails anymore. This deletion is irreversible, do you want to proceed?',
  'DOMAIN.NAME.CONFIG.NOTE': 'Please note:',
  'DOMAIN.NAME.CONFIG.NOTE0':
    'You must have administrative rights for this sender domain.',
  'DOMAIN.NAME.CONFIG.NOTE1':
    'To configure domains hosted on Tencent Cloud, go to https://console.cloud.tencent.com/cns. To configure domains hosted on other domain registration providers, follow the instructions provided to complete the configurations.',
  'DOMAIN.NAME.CONFIG.NOTE2':
    'After configuring the domain, the verification can take up 5 minutes to 2 hours. If your domain is not verified immediately, please wait a bit longer.',
  'DOMAIN.NAME.CONFIG.NOTE3':
    'After the domain name has been verified, refrain from deleting or editing the configured SPF and MX records. Doing this could could errors when sending out e-mails.',
  'DOMAIN.NAME.CONFIG.NOTE4':
    'In order to avoid conflicts with SPF and MX records, refrain from using corporate email domains.',
  'DOMAIN.NAME.CONFIG.SEND.DOMAIN.NAME.CONFIG': 'Domain name configuration',
  'DOMAIN.NAME.CONFIG.TYPE': 'Type',
  'DOMAIN.NAME.CONFIG.DOMAIN.NAME': 'Domain',
  'DOMAIN.NAME.CONFIG.RECORD.VALUE': 'Value logs',

  // 域名管理
  'SETTING.MANAGE.DOMAIN.AUTH': 'Email domains',
  'SETTING.MANAGE.DOMAIN.AUTH_NEW_TITLE': 'Email domains Status check',
  'SETTING.MANAGE.DOMAIN.AUTH.DESC':
    'Configure your domain before adding your sender address(es)',
  'SETTING.MANAGE.DOMAIN.AUTH.DESC1':
    'Verify your domain and add as many sender addresses as needed. Addresses do not need to be validated individually.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD': 'Add Domain',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.DOMAIN': 'Domain',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.SPF.STATUS': 'SPF status',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.DKM.STATUS': 'DKIM status',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.CHECK.STATUS': 'Status',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.VERIFY': 'Verified',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.NOT.VERIFY': 'Not verified',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.GO.VERIFY': 'Verify',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.EXPORT':
    'Export configuration details',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.EXPORT.DISABLED.TIP':
    'Configuration is being updated. Please try again later.',
  'SETTING.MANAGE.DOMAIN.AUTH.DELETE.TITLE':
    'Are you sure you want to delete this domain?',
  'SETTING.MANAGE.DOMAIN.AUTH.DELETE.MSG':
    'Once deleted, emails cannot be sent anymore from this domain.',

  // 域名管理 - 新增
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.TITLE': 'Enter domain name',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DESC':
    'Make sure you have administrative rights for this email domain.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.LABEL': 'Enter domain name',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.HOLDER': 'example.com',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.PLACEHOLDER':
    'Enter the domain name that needs to be verified',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.REST': 'example.com',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SUB.OVER': 'Submitted',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.TITLE':
    'Configure DNS records for domain verification',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.DESC':
    'Your domain administrator needs to complete the configuration with the domain service provider according to the checklist below. In general, within 72 hours after completing the configuration, the verification status of the domain will become "Verified".',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.DKIM.LABEL': 'DKIM status',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DKIM.MSG':
    'DKIM is a DNS-based email authentication protocol to verify that messages haven’t been tampered with in transit and to build a good reputation with email providers.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.SPF.LABEL': 'SPF status',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.MORE.GUID':
    'For more information, see <a href="{ url }" target="_blank">How to authenticate the sender domain</a>.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.CHECK.TITLE': 'Domain removal sandbox',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.CHECK.DESC':
    'After successfully verifying a domain, SmartLink will automatically remove the sandbox environment for your domain and initiate the 3 million daily email quota. This process will take approximately 1 business day. If you need to increase your quota or have any other questions, please contact the SmartLink service team via email.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.CHECK.LABEL': '{domain}',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.FORMAT':
    'Enter the correct domain name format',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.REPEAT':
    'This domain name has already been added',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG':
    'SPF is an additional DNS-based email authentication protocol, used to authenticate the sender and ensure that only authorized servers can send emails from your domain.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG.1':
    'If your domain does not already have an existing SPF record, please publish a TXT record using the value below. The name of the record can be empty or "@", depending on your DNS service.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG.2':
    'v=spf1 include:amazonses.com ~all',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG.3':
    "SPF records can contain multiple 'include' statements. If your domain already has an existing SPF record, you can add an include statement using the format below.",
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG.4':
    'v=spf1 include:example.com include:amazonses.com ~all',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.TITLE':
    'DMARC verification status',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.DESC':
    'Protect against spoofing & phishing, and help prevent emails from being marked as spam.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.NOTE':
    'Tip: Before configuring DMARC, please configure SPF and DKIM. SPF and DKIM should be authenticating messages for at least 48 hours before turning on DMARC.',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.CONFIG.DEMO':
    'Original DMARC record example:',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.CONFIG.SET':
    'For subsequent DMARC record modifications, please refer to: <a href="{ url }" target="_blank">Setup guide</a>',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.INFO.GMAIL.LABEL':
    'Gmail Domain Detection Configuration Status',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.INFO.GMAIL.MSG':
    'Once configured, Smartlink will monitor the Gmail sending reputation of your domain. Once any anomalies are detected, the system will automatically adjust the delivery strategy to ensure successful email delivery. The configuration result will be returned within 24 hours.',
  // 域名管理 - 详情页
  'SETTING.MANAGE.DOMAIN.DETAIL.LIST.TYPE': 'Type',
  'SETTING.MANAGE.DOMAIN.DETAIL.LIST.DOMAIN.NAME': 'Domain host',
  'SETTING.MANAGE.DOMAIN.DETAIL.LIST.VALUE': 'Value',
  'SETTING.MANAGE.DOMAIN.DETAIL.LIST.STATUS': 'Status',

  // 发件地址管理
  'SETTING.MANAGE.SEND.ADDRESS': 'Sender address',
  'SETTING.MANAGE.SEND.ADDRESS.DESC':
    'Set up your sender address(es) and use it immediately in a campaign',
  'SETTING.MANAGE.SEND.ADDRESS.NO.DATA.TIPS1': 'No addresses available,',
  'SETTING.MANAGE.SEND.ADDRESS.NO.DATA.TIPS2': 'please create a new one.',
  'SETTING.MANAGE.ADD.SEND.ADDRESS': 'Add sender email prefix',
  'SETTING.MANAGE.EDIT.SEND.ADDRESS': 'Edit sender email prefix',
  'SETTING.MANAGE.EMAIL.ADDRESS': 'Email address',
  'SETTING.MANAGE.PLEASE.ENTER.EMAIL.ADDRESS': 'Please enter an email address',
  'SETTING.MANAGE.PLEASE.ENTER.EMAIL.ADDRESS.BEFORE':
    'You can use numbers, letters, "_" and "-"',
  'SETTING.MANAGE.SEND.ADDRESS.DESC1':
    'Create an appropriate sender address for your domain.',
  'SETTING.MANAGE.SEND.ADDRESS.DESC2':
    'After setting up your general sender address, it can be used immediately in a campaign.',
  'SETTING.MANAGE.SEND.ADDRESS.DESC3':
    'Set up your sender address before launching a campaign. This will speed up your campaign creation process.',
  'SETTING.MANAGE.SEND.ADDRESS.DEL.TITLE':
    'Are you sure you want to delete this sender address?',
  'SETTING.MANAGE.SEND.ADDRESS.DEL.TIPS':
    'Once the address has been deleted, it cannot be selected anymore when creating a campaign.',
  'SETTING.MANAGE.COMMON.FROM.NAME': 'Commonly used sender name',

  // 发件人管理
  'SETTING.MANAGE.FROM.NAME': 'Sender name',
  'SETTING.MANAGE.FROM.NAME.DESC':
    'Set up your sender name(s) before sending your campaign',
  'SETTING.MANAGE.ADD.FROM.NAME': 'Add sender name',
  'SETTING.MANAGE.EDIT.FROM.NAME': 'Edit sender name',
  'SETTING.MANAGE.FROM.NAME.DESC1':
    'Create senders according to your needs. Set up your sender name before launching a campaign, otherwise this will need to be set up during the campaign creation.',
  'SETTING.MANAGE.PLEASE.ENTER.FROM.NAME': "Enter the sender's name",
  'SETTING.MANAGE.FROM.NAME.DEL.TITLE':
    'Are you sure you want to delete this sender name?',
  'SETTING.MANAGE.FROM.NAME.DEL.TIPS':
    'Once the sender name has been deleted, it cannot be selected anymore when creating a campaign.',

  // 测试邮箱管理
  'SETTING.MANAGE.TEST.LIST': 'Tester',
  'SETTING.MANAGE.TEST.LIST.ADD': 'Add tester',
  'SETTING.MANAGE.TEST.LIST.DESC':
    'It is highly recommended to set up a list of testers and send them a test campaign before launching your campaign.',
  'SETTING.MANAGE.TEST.ADD.TITLE': 'Add',
  'SETTING.MANAGE.TEST.EDIT.TITLE': 'Edit',
  'SETTING.MANAGE.SELECT.LANGUAGE': 'Select language',
  'SETTING.MANAGE.PLEASE.ENTER.ADDRESS': 'Please enter a valid email address',
  'SETTING.MANAGE.PLEASE.ENTER.TEST.EMAIL.ADDRESS': 'Enter test email address',
  'SETTING.MANAGE.TEST.DEL.TITLE':
    'Are you sure you want to delete this tester?',

  // API key - 列表
  'SETTING.MANAGE.API.KEY': 'API Key',
  'SETTING.MANAGE.API.KEY.DESC':
    "Developers can use SmartLink's APIs for easy integration",
  'SETTING.MANAGE.API.KEY.DESC1':
    "Developers can use SmartLink's APIs for easy integration <a href={url} target='_blank'>Learn more</a>",

  'SETTING.MANAGE.API.KEY.CREATE': 'Create key',
  'SETTING.MANAGE.API.KEY.ADD': 'Create API key',
  'SETTING.MANAGE.API.KEY.EDIT': 'Edit API key',
  'SETTING.MANAGE.API.KEY.REVOKE': 'Revoke API key',
  'SETTING.MANAGE.API.KEY.SAVE.AND.CONFIG': 'Save & configure',
  'SETTING.MANAGE.API.KEY.CREATED.TIME': 'Created on',
  'SETTING.MANAGE.API.KEY.CREATED.BY': 'Created by',
  'SETTING.MANAGE.API.KEY.REVOKE.ON.DATE': 'Revoked on {date}',
  'SETTING.MANAGE.API.KEY.HISTORY.TIPS':
    'Setting or revoking historical data is currently not supported.',
  'SETTING.MANAGE.API.KEY.VALUE': 'API key',
  'SETTING.MANAGE.API.KEY.CREATE.TIPS.TITLE':
    'Before you begin, please note that:',
  'SETTING.MANAGE.API.KEY.CREATE.TIPS.1':
    "You can see the full key immediately in this pop-up panel. After the key is saved, you won't be able to see the full key anymore, just the name you assigned to it.",
  'SETTING.MANAGE.API.KEY.CREATE.TIPS.2':
    'For security reasons, never share your API key with a third party.',
  'SETTING.MANAGE.API.KEY.NEW.VALUE': 'New API key',
  'SETTING.MANAGE.API.KEY.NAME': 'Name',
  'SETTING.MANAGE.API.KEY.NAME.PLACEHOLDER': 'Enter API name',
  'SETTING.MANAGE.API.KEY.NAME.NOT.EMPTY': 'API name cannot be empty',
  'SETTING.MANAGE.API.KEY.REMARKS.PLACEHOLDER': 'Add remarks',
  'SETTING.MANAGE.API.KEY.REMARKS.TIPS':
    'Enter a descriptive remark to indicate the purpose of this API key.',
  'SETTING.MANAGE.API.KEY.REVOKE.DESC.TITLE':
    'Are you sure you want to revoke this key?',
  'SETTING.MANAGE.API.KEY.REVOKE.DESC.TIPS1':
    'After the key is revoked, the API using this key will not be able to update data in SmartLink anymore.',
  'SETTING.MANAGE.API.KEY.REVOKE.DESC.TIPS2':
    'Make sure your project is not affected by revoking this key.',
  'SETTING.MANAGE.API.KEY.REVOKE.CONFIRM.LABEL':
    'Type <b>REVOKE</b> to confirm',

  // API key - 详情
  'SETTING.MANAGE.API.KEY.DETAILS': 'API key details',
  'SETTING.MANAGE.API.KEY.DETAILS.BASIC.INFO': 'Basic information',
  'SETTING.MANAGE.API.KEY.DETAILS.TIPS1':
    'For security reasons, the API key will be masked after it is created.',
  'SETTING.MANAGE.API.KEY.DETAILS.TIPS2':
    'If you lose the key, you will need to generate a new key and update the data sources using them.',
  'SETTING.MANAGE.API.KEY.DETAILS.TIPS3':
    'You can refer to <a href={url} target="_blank">Smartlink</a> for more information.',
  'SETTING.MANAGE.API.KEY.DETAILS.API.SETTINGS': 'API settings',
  'SETTING.MANAGE.API.KEY.DETAILS.API.SETTINGS.DESC':
    'If this is not set up, new contacts will be added to the contacts list directly through the API.<br/>You can set up player journey for this API. ',
  'SETTING.MANAGE.API.KEY.DETAILS.AUTOMATE.1':
    'Player journey can send a confirmation email to contacts who are added through an API. After the contact confirms their email, they will be added to the contacts list.',
  'SETTING.MANAGE.API.KEY.DETAILS.AUTOMATE.2':
    'Player journey can send welcome emails to newly added contacts.',

  // 拒绝列表
  'SETTING.MANAGE.REJECT.LIST': 'Blocklist',
  'SETTING.MANAGE.REJECT.LIST.DESC':
    'When an email is bounced or marked as spam by the recipient, SmartLink will stop sending more emails to that email address temporarily.',
  'SETTING.MANAGE.REJECT.LIST.DESC.1':
    'When your email is bounced or if a recipient marks your email as spam, SmartLink will stop sending more email to that address for a period of time, depending on the frequency of occurrences and the severity of the issue.',
  'SETTING.MANAGE.REJECT.LIST.DESC.2':
    'SmartLink also maintains a global blocklist, which automatically filters out email addresses from receiving emails from campaigns. Bounced email addresses are directly added to this global blocklist.',
  'SETTING.MANAGE.REJECT.LIST.DESC.3':
    "You can manually remove email addresses from the blocklist, but please be cautious. Regularly removing email addresses from your blocklist could cause your domain's reputation to drop.",
  'SETTING.MANAGE.REJECT.LIST.ADD': 'Add to blocklist',
  'SETTING.MANAGE.REJECT.LIST.SEARCH.PLACEHOLDER': 'Search email',
  'SETTING.MANAGE.REJECT.LIST.EMAIL.ADDRESS': 'Email address',
  'SETTING.MANAGE.REJECT.LIST.REASON': 'Reason',
  'SETTING.MANAGE.REJECT.LIST.CUSTOM': 'Custom',
  'SETTING.MANAGE.REJECT.LIST.INVALID.EMAIL': 'Invalid email',
  'SETTING.MANAGE.REJECT.LIST.INVALID.EMAIL.TIPS':
    'Email check tool detection ({time})',
  'SETTING.MANAGE.REJECT.LIST.HARD.BOUNCE': 'Hard bounce',
  'SETTING.MANAGE.REJECT.LIST.SPAM': 'Spam',
  'SETTING.MANAGE.REJECT.LIST.LAST.JOIN.DATE': 'Date added',
  'SETTING.MANAGE.REJECT.LIST.LAST.ADDED.BY': 'Added by',
  'SETTING.MANAGE.REJECT.LIST.EXPIRATION.DATE': 'Date removed',
  'SETTING.MANAGE.REJECT.LIST.NEVER': 'Never',
  'SETTING.MANAGE.REJECT.LIST.DOWNLOAD.SAMPLE.NAME': 'Download CSV template',
  'SETTING.MANAGE.REJECT.LIST.CANCEL.IMPORT.SUCCESS.TOTAL':
    "Email addresses that are duplicates or have an invalid format will be removed automatically. <span class='primary-weight-text'>{num}</span> contacts will be imported, click 'Confirm' to proceed.",
  'SETTING.MANAGE.REJECT.LIST.IMPORT.CSV.DROP.FILES.LIMIT':
    'Only supports CSV files. Maximum upload file size: 20MB.',
  'SETTING.MANAGE.REJECT.LIST.IMPORT.CSV.ERR.TYPE':
    'Convert file to CSV, then try to upload again.',
  'SETTING.MANAGE.REJECT.LIST.IMPORT.CSV.ERR.SIZE':
    'File size is too large, please reduce the file size.',
  'SETTING.MANAGE.REJECT.LIST.IMPORT.CSV.ERR.EMAIL.NONE':
    'File contains invalid email addresses.',

  // 拒绝列表 - 新增
  'SETTING.MANAGE.REJECT.ADD.DESC':
    'Enter emails to be added to your blocklist. Emails added manually will never get automatically removed.',
  'SETTING.MANAGE.REJECT.ADD.EMAIL': 'Manually add emails',
  'SETTING.MANAGE.REJECT.ADD.EMAIL.PLACEHOLDER':
    'Enter one email address per line',
  'SETTING.MANAGE.REJECT.ADD.PLEASE.ENTER.EMAIL':
    'Please enter an email address',
  'SETTING.MANAGE.REJECT.ADD.MAX.EMAIL':
    'Maximum number of emails exceeded by {maxNum}, please delete some and try sending again.',
  'SETTING.MANAGE.REJECT.ADD.FORMAT.EMAIL':
    'The email address entered in row [{errorIndex}] is incorrect',
  'SETTING.MANAGE.REJECT.ADD.REPETITION.EMAIL':
    'Duplicate emails detected, please remove them and try again.',
  'SETTING.MANAGE.REJECT.ADD.EMAIL.NUM': '{num} new email address',
  'SETTING.MANAGE.REJECT.ADD.REASON': 'Reason for blocklisting',
  'SETTING.MANAGE.REJECT.ADD.PLEASE.ENTER.REASON':
    'Enter the reason for blocklisting',
  'SETTING.MANAGE.REJECT.DEL.TITLE':
    'Are you sure you want to remove this email address?',
  'SETTING.MANAGE.REJECT.DEL.DESC':
    'SmartLink will resume sending emails to this email after it has been removed from the blocklist. However, if the email gets bounced or gets marked as spam, your domain reputation might get affected.',
  'SETTING.MANAGE.REJECT.DEL.TOOLTIP.1':
    'Email addresses that were automatically added to the blocklist cannot be removed manually. Please contact {customerServiceEmail}.com if you want to remove them.',
  'SETTING.MANAGE.REJECT.DEL.SUCCESS':
    '{email} successfully removed from the blocklist',
  'SETTING.MANAGE.REJECT.ADD.SUCCEEDED':
    '{num} email addresses have been added to your blocklist',
  'SETTING.MANAGE.REJECT.ADD.TAB.1': 'Manual',
  'SETTING.MANAGE.REJECT.ADD.TAB.2': 'Import CSV',
  'SETTING.MANAGE.REJECT.ADD.DROP.FILES': 'Choose a file or drag it here',

  // 发送频率控制
  'SENDING.FREQUENCY.CONTROL.EFFECTIVE.DATE': '*Starting date: {time}',
  'SENDING.FREQUENCY.CONTROL.EMAIL.FREQUENCE.TITLE': 'Delivery frequency',
  'SENDING.FREQUENCY.CONTROL.EMAIL.FREQUENCE.DESC':
    'Set the maximum number of emails a recipient can receive within the specified number of days.',
  'SENDING.FREQUENCY.CONTROL.ON.STATE.1':
    '<span class="color-primary font-weight-700">Active</span>',
  'SENDING.FREQUENCY.CONTROL.ON.STATE.0':
    '<span class="color-999 font-weight-700">Inactive</span>',
  'SENDING.FREQUENCY.CONTROL.RESTRICTION.EMAIL': 'Email(s)',
  'SENDING.FREQUENCY.CONTROL.HOUR': 'Hour(s)',
  'SENDING.FREQUENCY.CONTROL.DAY': 'Day(s)',
  'SENDING.FREQUENCY.CONTROL.WEEK': 'Week(s)',
  'SENDING.FREQUENCY.CONTROL.MONTH': 'Month(s)',
  'SENDING.FREQUENCY.CONTROL.TITLE': 'Email frequency controls',
  'SENDING.FREQUENCY.CONTROL.DESC':
    'Set limits to the number of emails sent to the same recipient in a period of time.',
  'SENDING.FREQUENCY.CONTROL.SUB.DESC':
    'Set a limit to the number of emails sent to a single recipient within a period of time',
  'SENDING.FREQUENCY.CONTROL.DESC.TIPS':
    'These settings will only affect email campaigns. Emails will not be delivered to recipients who have already reached the limit.<br/>If you have a email campaigns that should ignore this limitation, you can choose to ignore this limit when launching that campaign.<br/>Transactional emails, journeys and confirmation emails are not affected by these settings and will be sent out without any limitations.',
  'SENDING.FREQUENCY.CONTROL.AUTH.TIPS':
    'Can only be activated by Owners, Admin and Managers.',
  'SENDING.FREQUENCY.CONTROL.STATUS.1': 'Active',
  'SENDING.FREQUENCY.CONTROL.STATUS.0': 'Inactive',
  'SENDING.FREQUENCY.CONTROL.STATUS.DESC.1':
    'Email frequency controls is activated',
  'SENDING.FREQUENCY.CONTROL.STATUS.DESC.0':
    'After activating the email sending control, it will affect the next campaign you launch.',
  'SENDING.FREQUENCY.CONTROL.RESTRICTION.SET.TITLE': 'Control settings',
  'SENDING.FREQUENCY.CONTROL.RESTRICTION.SET.DESC':
    'Set the maximum number of emails a recipient can receive within the specified number of days.',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.TITLE.0':
    'Are you sure you want to activate this?',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.DESC.0':
    'Confirm your email limitation',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.TITLE.1':
    'Are you sure you want to deactivate the email sending control?',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.DESC.1':
    'After deactivating, there will be no email limitations anymore.',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.TO.1': 'Successfully activated',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.TO.0': 'Successfully deactivated',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.TITLE':
    'Email frequency adjustment confirmation',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.DESC':
    '‌<span class="color-666">You are adjusting the email frequency:</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.EFFECT':
    'Upon confirmation, the number of emails sent will be recalculated starting from today.',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.OLD.1':
    '‌<span class="color-666">• Before: Allow ‌[{num}] email(s) in ‌[{days}] day(s‌)</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.OLD.2':
    '‌<span class="color-666">• Before: Allow ‌[{num}] email(s) in ‌[{days}] week(s‌)‌</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.OLD.3':
    '‌<span class="color-666">• Before: Allow ‌[{num}] email(s) in ‌[{days}] month(s‌)</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.NEW.1':
    '<b class="color-333">• After: Allow ‌[{num}] email(s) in ‌[{days}] day(s‌)‌</b>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.NEW.2':
    '<b class="color-333">• After: Allow ‌[{num}] email(s) in ‌[{days}] week(s‌)</b>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.NEW.3':
    '<b class="color-333">• After: Allow ‌[{num}] email(s) in ‌[{days}] month(s‌)</b>',
  // 邮件发送冷却时间
  'SENDING.FREQUENCY.CONTROL.COOLING.TITLE': 'Wait time in between emails',
  'SENDING.FREQUENCY.CONTROL.COOLING.DESC':
    'If a new email is sent during the waiting period of a recipeint, the recipient will be filtered out from the campaign automatically.',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.DESC':
    '‌<span class="color-666">You are adjusting the wait time in between emails:</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.OLD.1':
    '‌<span class="color-666">• Before: The wait time in between emails is {num} hour(s)</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.OLD.2':
    '‌<span class="color-666">• Before: The wait time in between emails is {num} day(s‌)‌</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.NEW.1':
    '<b class="color-333">• After: The wait time in between emails is {num} hour(s)</b>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.NEW.2':
    '<b class="color-333">• After: The wait time in between emails is {num} day(s‌)‌</b>',

  // 回调
  'SETTING.MANAGE.WEB.HOOKS.TITLE': 'Webhooks',
  'SETTING.MANAGE.WEB.HOOKS.DESC':
    'Create webhooks to synchronize events to your server in real time.',
  'SETTING.MANAGE.WEB.HOOKS.ADD.YOUR.FIRST.WEBHOOK':
    'Create your first webhook',
  'SETTING.MANAGE.WEB.HOOKS.ADD.NEW.WEBHOOK': 'Create new webhook',
  'SETTING.MANAGE.WEB.HOOKS.CREATE.NEW.WEBHOOK': 'Create new webhook',
  'SETTING.MANAGE.WEB.HOOKS.ADD.WEBHOOK.MAX.TIPS': 'Webhook limit reached',
  'SETTING.MANAGE.WEB.HOOKS.URL': 'URL',
  'SETTING.MANAGE.WEB.HOOKS.TRIGGERED.BY': 'Triggered by',
  'SETTING.MANAGE.WEB.HOOKS.EVENTS': 'Triggered count',
  'SETTING.MANAGE.WEB.HOOKS.LAST.SUCCESSFUL.AT': 'Last successful delivery',
  'SETTING.MANAGE.WEB.HOOKS.KEY': 'Key',
  'SETTING.MANAGE.WEB.HOOKS.LAST.EDIT.BY': 'Last edited by',
  'SETTING.MANAGE.WEB.HOOKS.KEY.DESC.TITLE': 'Secret key',
  'SETTING.MANAGE.WEB.HOOKS.KEY.DESC.CONTENT':
    'SmartLink will sign all webhook deliveries, allowing you to verify its legitimacy. This is not a mandatory step, but it is highly recommended.',
  'SETTING.MANAGE.WEB.HOOKS.KEY.DESC.MORE.DETAILS': 'More details',
  'SETTING.MANAGE.WEB.HOOKS.SEND.TEST': 'Send test',
  'SETTING.MANAGE.WEB.HOOKS.SEND.TEST.SUCCEEDED':
    'Test event posted successfully',
  'SETTING.MANAGE.WEB.HOOKS.DEL.HEADER':
    'Are you sure you want to delete this webhook?',
  'SETTING.MANAGE.WEB.HOOKS.DEL.TIPS':
    'Deleted webhooks cannot be restored. Are you sure you want to proceed?',
  'SETTING.MANAGE.WEB.HOOKS.RESET.KEY': 'Reset key',
  'SETTING.MANAGE.WEB.HOOKS.RESET.KEY.SUCCEEDED': 'Reset successfully',
  'SETTING.MANAGE.WEB.HOOKS.RESET.KEY.HEADER': 'Reset key ?',
  'SETTING.MANAGE.WEB.HOOKS.RESET.KEY.TIPS1':
    "Resetting a webhook's key will generate a new random key. This change will take effect immediately.",
  'SETTING.MANAGE.WEB.HOOKS.ADD': 'Add a webhook',
  'SETTING.MANAGE.WEB.HOOKS.EDIT': 'Edit webhook',
  'SETTING.MANAGE.WEB.HOOKS.URL.TO.POST.TO': 'Endpoint URL',
  'SETTING.MANAGE.WEB.HOOKS.URL.TO.POST.TO.PLACEHOLDER':
    "Needs to be 'https://' or 'http://'",
  'SETTING.MANAGE.WEB.HOOKS.WHEN.CONTACT.CHANGES.TO':
    'When a contact changes to',
  'SETTING.MANAGE.WEB.HOOKS.DESCRIPTION': 'Description',

  // 收件人信息
  'SETTING.MANAGE.RECIPIENT.INFO': 'Recipient settings',
  'SETTING.MANAGE.AREA.MANAGE': 'Region management',
  'SETTING.MANAGE.AREA.MANAGE.DESC':
    'Group regions into custom geographical zones. Improve data clarity in your reports and contacts dashboard.',

  // 指引弹窗
  'SETTING.MANAGE.AREA.DIALOG.DESC':
    'Manage dozens of regions with ease by grouping them together into zones. Adjustments made here will be reflected on other pages after a refresh.',
  'SETTING.MANAGE.AREA.DIALOG.TIP1':
    '1. Create a custom zone and add relevant regions.',
  'SETTING.MANAGE.AREA.DIALOG.TIP2':
    '2. View the number of contacts in each zone in the Contacts Dashboard.',
  'SETTING.MANAGE.AREA.DIALOG.TIP3':
    '3. Select all regions within a zone with a single click in Segments.',

  // 添加区域
  'SETTING.MANAGE.AREA.ADD.TITLE': 'Add custom zone',
  'SETTING.MANAGE.AREA.ADD.NEW.CREATE': 'Create custom zone',
  'SETTING.MANAGE.AREA.EDIT.TITLE': 'Edit zone',
  'SETTING.MANAGE.AREA.ADD.PLACEHOLDER': 'Enter zone name',
  'SETTING.MANAGE.AREA.ADD.SELECTED': 'Selected region(s)',
  'SETTING.MANAGE.AREA.ADD.SELECT': 'Select region(s)',
  'SETTING.MANAGE.AREA.ADD.SELECT.PLACEHOLDER': 'Select region(s)',
  'SETTING.MANAGE.AREA.SEARCH': 'Search region',
  'SETTING.MANAGE.AREA.SEARCH.AREA': 'Search zone',
  'SETTING.MANAGE.AREA.ADD.CONFIRM': 'Confirm',
  'SETTING.MANAGE.AREA.ADD.CANCEL': 'Cancel',
  'SETTING.MANAGE.AREA.ADD.SUCCEEDED': 'Created successfully',
  'SETTING.MANAGE.AREA.EDIT.SUCCEEDED': 'Edited successfully',
  'SETTING.MANAGE.AREA.CREATE.ZONE.LABEL': 'Zone name',
  'SETTING.MANAGE.AREA.NOT.EMPTY':
    'Zone cannot be selected, please create a new one',
  'SETTING.MANAGE.AREA.NAME.REQUIRED': 'Region name is mandatory',
  'SETTING.MANAGE.AREA.NAME.UNABLE.EMPTY': 'Region name cannot be empty',
  'SETTING.MANAGE.AREA.NAME.EXIST': 'Zone name already exists',
  'SETTING.MANAGE.AREA.ZONE.NAME': 'Zone name',

  // 删除
  'SETTING.MANAGE.AREA.DEL.TITLE': 'Delete zone',
  'SETTING.MANAGE.AREA.DEL.TIPS':
    '"<b class="color-333">{name}</b>" will be permanently deleted and the region(s) in this zone will move to <b class="color-333">\'Others\'</b>.',
  'SETTING.MANAGE.AREA.DEL.SUCCEEDED': 'Deleted successfully',

  // 移动区域
  'SETTING.MANAGE.AREA.MOVE': 'Move Region(s)',
  'SETTING.MANAGE.AREA.MOVE.CURRENT': 'Current zone',
  'SETTING.MANAGE.AREA.MOVE.PLACEHOLDER': 'Select region(s) to move out',
  'SETTING.MANAGE.AREA.MOVE.TARGET': 'Target zone',
  'SETTING.MANAGE.AREA.MOVE.SELECT': 'Select zone to move to',
  'SETTING.MANAGE.AREA.MOVE.SUCCEEDED': 'Moved successfully',

  // 区域管理
  'SETTING.MANAGE.AREA.DIVIDE': 'Geographical zones',
  'SETTING.MANAGE.AREA.ZONE': 'Zone',
  'SETTING.MANAGE.AREA.REGION': 'Region(s)',
  'SETTING.MANAGE.AREA.ACTION': 'Action',
  'SETTING.MANAGE.AREA.OTHER': 'Others',
  'SETTING.MANAGE.AREA.EDIT': 'Edit',
  'SETTING.MANAGE.AREA.DELETE': 'Delete',
  'SETTING.MANAGE.AREA.COLLAPSE': 'Collapse',

  // 二次确认邮件配置
  'SETTING.MANAGE.OPT.IN.TITLE': 'Double opt-in email',
  'SETTING.MANAGE.CREATE.MAIL.SUBJECT': 'Enter subject line',
  'SETTING.MANAGE.OPT.IN.DESC':
    'This email will be sent automatically when a contact is added via API or submits a form with a "Pending" subscription status. The contact must confirm to complete the subscription.',
  'SETTING.MANAGE.OPT.IN.DESC.2':
    'This confirmation email will be sent automatically when importing contacts as "Pending" via API (V4 or later). Only contacts who confirm manually will become "Subscribed".',
  'SETTING.MANAGE.OPT.IN.ACTIVE': 'Configured',
  'SETTING.MANAGE.OPT.IN.NOT.ACTIVE': 'Not configured',
  'SETTING.MANAGE.OPT.IN.EXPAND.DESC':
    'Advanced settings for importing contacts by this API Key',
  'SETTING.MANAGE.OPT.IN.COLLAPSE': 'Expand and configure',
  'SETTING.MANAGE.OPT.IN.DEFAULT.SETTING.TITLE': 'Double opt-in (default)',
  'SETTING.MANAGE.OPT.IN.DEFAULT.SETTING.DESC':
    'Set up your double opt-in sender information and email content. These settings are directly applied to subscriptions coming from your APIs and Forms.',
  'SETTING.MANAGE.OPT.IN.SETTING.TITLE': 'Double opt-in settings',
  'SETTING.MANAGE.OPT.IN.SETTING.SAVE.AND.BACK': 'Save & configure',
  'SETTING.MANAGE.OPT.IN.IMPORT.CONTACT.CONFIG': 'Contact import settings',
  'SETTING.MANAGE.OPT.IN.IMPORT.CONTACT.CONFIG.TIPS1':
    'This configuration only applies to APIv4 and higher.',
  'SETTING.MANAGE.OPT.IN.IMPORT.CONTACT.CONFIG.TIPS2':
    'To import contacts through this API, make sure to complete these configurations.',
  'SETTING.MANAGE.OPT.IN.TO.CONFIG': 'Edit settings',
  'SETTING.MANAGE.OPT.IN.DEFAULT.CONFIG': 'Default settings',
  'SETTING.MANAGE.OPT.IN.DEFAULT.CONFIG.TIPS1':
    'Default settings are incompleted. ',
  'SETTING.MANAGE.OPT.IN.DEFAULT.CONFIG.TIPS2': 'Edit settings.',
  'SETTING.MANAGE.OPT.IN.CUSTOM.CONFIG': 'Custom settings',
  'SETTING.MANAGE.OPT.IN.CUSTOM.CONFIG.SETTINGS': 'Custom settings',
  'SETTING.MANAGE.OPT.IN.SAVE.DESC':
    'These double opt-in settings (sender details and email content) will be synchronized to all relevant APIs and Forms. Are you sure you want to continue?',

  'SETTING.MANAGE.OPT.IN.METHOD.SINGLE.TITLE': 'Single opt-in',
  'SETTING.MANAGE.OPT.IN.METHOD.SINGLE.DESC':
    'Contacts are subscribed immediately after form submission. This help maximizes list growth.',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.PARTICULAR.TITLE':
    'Smart double opt-in (Recommended)',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.PARTICULAR.TIPS':
    'Double opt-in is only enabled for countries/regions where it is mandated by law: {country}',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.PARTICULAR.DESC1':
    "A confirmation email is sent to new contacts only in regions where required. Status is 'Pending' until confirmed.",
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.PARTICULAR.DESC2':
    'Applies to: <span class="color-333 font-weight-700">{country}</span>.',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.ALL.TITLE': 'Double opt-in for everyone',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.ALL.DESC1':
    "All new contacts receive a confirmation email. Status is 'Pending' until confirmed. Ensures list quality and user consent.",
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.ALL.DESC2':
    "This status will change to 'Subscribed' after the player clicks on the confirmation link in the email.",
  'SETTING.MANAGE.OPT.IN.TEMPLATE.SELECT.LABEL': 'Template type',
  'SETTING.MANAGE.OPT.IN.SYNC.CONTACT.SUCCESS': 'Has been synchronized',
  'SETTING.MANAGE.OPT.IN.TEMPLATE.OPTIONS1': 'System-prebuilt templates',
  'SETTING.MANAGE.OPT.IN.TEMPLATE.OPTIONS2': 'Marketing email templates',
  'SETTING.MANAGE.OPT.IN.SYNC.CONTACT': 'Sync to other languages',
  'SETTING.MANAGE.OPT.IN.TEMPLATE.SELECT.BUBBLE':
    'If you choose a system-prebuilt template, the subject and template content will be automatically filled, and you only need to fill in the email address within the template. If you choose a marketing email template, you need to fill in the subject and template content for each language according to your requirements.',
  'SETTING.MANAGE.OPT.IN.METHOD.CUSTOMIZED.TEMPLATES':
    'Customized email from marketing templates - ',
  'SETTING.MANAGE.OPT.IN.SELECT.TEMP.TIPS':
    ' Select a template that has a confirmation link and no keys.',
  'SETTING.MANAGE.OPT.IN.SELECT.TEMP.TIPS.2':
    ' Select a template that has a confirmation link and no keys or forms.',
  'SETTING.MANAGE.OPT.IN.BUILT.IN.TEMP.LABEL': 'Built-in template',
  'SETTING.MANAGE.OPT.IN.BUILT.IN.TEMP.DEFAULT.TEMPLATE.LABEL':
    'Default double opt-in email template',
  'SETTING.MANAGE.OPT.IN.CONFIRM.HEADER':
    'Do you want to save the changes you have made?',
  'SETTING.MANAGE.OPT.IN.CONFIRM.TIPS':
    'Changes will take effect immediately and apply to contacts imported from this API (V4 or later).',
  'SETTING.MANAGE.OPT.IN.CHECKBOX.SELECT':
    ' Save this double opt-in email content to default settings.	',
  'SETTING.MANAGE.OPT.IN.SELECT.TIPS':
    'If selected, the content will be saved to the Double Opt-in settings and used as the default content for other APIs or forms.',

  // 错误码提示
  'SETTING.SENDER.ADDRESS.10093':
    'Please verify the sender name configurations for the double opt-in emails',
  'SETTING.SENDER.NAME.10094':
    'Please verify the sender address configurations for the double opt-in emails',
};
